import React, { useEffect, useState, useRef } from "react";

import Api from "../../api";
import { getSearchParams } from '../../utils/tool';
import storage from "../../utils/storage";
const KnowledgeView = () => {
    const containerRef = useRef(null);
    const [jsSDK, setJsSDK] = useState(null);
    const userInfo = storage.getItem("userInfo") || {};

    // 编辑器加载完成时回调事件
    var onAppReady = function () {
        console.log("编辑器加载完成");
    };
    // 文档加载完成时回调事件
    var onDocumentReady = async function (event) {
        console.log("文档已加载完成");
    }

    let cxoConfig = {
        "document": {
            "fileType": "",
            "key": "",
            "title": "",
            "url": "",
            "permissions": {
                "download": false,
                "edit": false,
                "print": false
            }
        },
        "height": '',
        "editorConfig": {
            // "callbackUrl": '',
            "user": {
                "id": userInfo.jobNum,
                "name": userInfo.userName
            },
            "customization": {
                "forcesave": true,
                "rightMenu": false,
                "logo": {
                    "image": "",
                },
                "about": false,
            },
        },
        "events": {
            'onDocumentReady': onDocumentReady,
            'onAppReady': onAppReady
        },
    }

    useEffect(() => { 
        // wps/changxie
        if(storage.getItem("previewType") === "changxie"){
            getCXFileUrl();
        }else{
            getWPSFileUrl();
        }

        
    }, []);

    // 获取预览地址
    const getCXFileUrl = async () => {
        try { 
            console.log(getSearchParams().id)
            
            let res = null;
            
            if(getSearchParams().id && getSearchParams().id != "null" && getSearchParams().id != 'undefined'){
                res = await Api.Common.getPolicyAttachFile({ data:{policyAttachId: getSearchParams().id}});
            }else{
                res = await Api.Common.getFileByFileId({ data:{fileId: getSearchParams().fileId}});
            }
            
            if (res && (res.code === 200 || res.code === 0) && res.data) {
                const _data = res.data;
                let divHeight = document.querySelector('.knowledgeViewFrame');
                cxoConfig.height = (divHeight.offsetHeight)+'px';
                cxoConfig.document.url = _data.url;
                cxoConfig.document.key = _data.id;
                cxoConfig.document.title = _data.name;
                cxoConfig.document.fileType = _data.type;

                console.log('cxoConfig:', cxoConfig)

                let _docEditor = new CXO_API.CXEditor("office", cxoConfig);
            }
        } catch (error) {}
    };


    // 获取WPS内容
    const getWPSFileUrl = async () => {
        try { 

            let res = null;
            console.log('getWPSFileUrl', getSearchParams().fileId)
            
            if(getSearchParams().fileId && getSearchParams().fileId != "null"){
                res = await Api.Knowledge.getPreviewUrlByFileId({ data:{fileId: getSearchParams().fileId}});
            }else{
                res = await Api.Knowledge.getPolicyAttachPreviewUrl({ data:{policyAttachId: getSearchParams().id}});
            }
            
            if (res && (res.code === 200 || res.code === 0) && res.data) {
                let link = res.data.link || res.data.data.link;
                const jsSdk = OpenSDK.config({
                    url: link,
                    mount: document.querySelector(".custom-mount"),
                });
                if (jsSdk.iframe) {
                    jsSdk.iframe.width = "100%";
                    jsSdk.iframe.height = "100%";
                }
                setJsSDK(jsSdk);
            }
        } catch (error) {}
    };


    return <div className="knowledgeViewFrame" style={{ height: "100%" }}>

        <div className="custom-mount" id="office" ref={containerRef}  style={{ height: "100%" }}></div>
        
    </div>;
}
export default KnowledgeView;